import {curveSegments} from "../../../../consts";
import * as THREE from "three";
import {createShape, twistGeometryV2} from "../../../../utils";
import {GeneratorValues} from "../../../product-types";

export const vase = (radius: number, values: GeneratorValues) => {
    const shape = new THREE.Shape()

    shape.lineTo(0, 1)
    shape.lineTo(1, 4)
    shape.lineTo(2, 0)

    const points = shape.getPoints()

    const outerShape = createShape(points, values.count as number, radius)

    const extrudeSettings = {
        depth: values.height,
        bevelEnabled: true,
        bevelSegments: 2,
        curveSegments: curveSegments,
        steps: 32,
        bevelSize: 1,
        bevelThickness: 1
    }

    const geometry = new THREE.ExtrudeGeometry(outerShape, extrudeSettings)

    return twistGeometryV2(geometry, values.height, values.twistAmount as number, (y) => {
        const max = 100
        const step = (Math.PI * 1.75) / values.height
        const start = Math.PI * -0.75
        return ((Math.sin(start + y * step) + 1) / 2) * max
    })
}